import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme } from "@mui/material";
export const FormWraper = ({ children, onClick }) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("md"));
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    return (_jsx(Box, { sx: {
            backgroundColor: "#FFFFFF",
            borderRadius: 2,
            position: "relative",
            border: "1px solid #00244D33",
            boxShadow: " 0px 40px 56px 0px #00000014,  0px 16px 40px 0px #0000000F, 0px 4px 8px 0px #0000000A;",
        }, children: children }));
};
